import hasSelectedSaveView from './hasSelectedSaveView';
import {
    lazyGetSavedCalendarViewsMap,
    MAX_SAVED_CALENDAR_VIEWS,
} from 'owa-save-calendar-view-data';

export default function isSaveViewButtonDisabled(): boolean {
    if (hasSelectedSaveView()) {
        return true;
    }

    const getSavedCalendarViewsMap = lazyGetSavedCalendarViewsMap.tryImportForRender();
    if (getSavedCalendarViewsMap && getSavedCalendarViewsMap().size >= MAX_SAVED_CALENDAR_VIEWS) {
        return true;
    }

    return false;
}
